import { createOverrideRegistry } from '@override';
import { useMemo } from 'react';

import { NewBatch, useBuildColumns, useDownloadBatchReport, useGenerateBatchReport } from './batches';
import { Sidebar } from './layout/Sidebar';
import { WalletInformation } from './manage-account/WalletInformation';

export const useOverridesModule = () => {
  return useMemo(() => {
    const registry = createOverrideRegistry();

    registry.register({
      NewBatch,
      Sidebar,
      WalletInformation,
    });

    registry.registerHooks({
      useBuildColumns,
      useGenerateBatchReport,
      useDownloadBatchReport,
    });

    return registry;
  }, []);
};
